var _style, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReplayFill01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 25.058 25.059",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#425061}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.529 1.175C6.261 1.182 1.182 6.261 1.175 12.529c.007 6.268 5.086 11.348 11.354 11.355 6.268-.007 11.348-5.087 11.355-11.355-.008-6.268-5.087-11.347-11.355-11.354z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-replay"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    className: "st1",
    d: "M12.529 25.059C5.612 25.051.008 19.446 0 12.529.008 5.613 5.613.008 12.529 0c6.916.008 12.521 5.613 12.529 12.529-.007 6.917-5.612 12.522-12.529 12.53zm0-23.884C6.261 1.182 1.182 6.261 1.175 12.529c.007 6.268 5.086 11.348 11.354 11.355 6.268-.007 11.348-5.087 11.355-11.355-.008-6.268-5.087-11.347-11.355-11.354z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    className: "st1",
    d: "M13.085 7.411V5.543a.488.488 0 00-.306-.457.484.484 0 00-.539.107l-2.65 2.65a.488.488 0 000 .699l2.65 2.65a.484.484 0 00.538.107.49.49 0 00.306-.458V8.799a4.493 4.493 0 014.108 4.462 4.508 4.508 0 01-4.5 4.5 4.51 4.51 0 01-4.5-4.5.7.7 0 00-.7-.694.7.7 0 00-.694.694 5.9 5.9 0 005.894 5.9 5.9 5.9 0 005.894-5.9 5.883 5.883 0 00-5.501-5.85z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReplayFill01);
export default __webpack_public_path__ + "static/media/icon-replay-fill-01.e198e830.svg";
export { ForwardRef as ReactComponent };